import { render } from "./MonitoringScreen.vue?vue&type=template&id=1ff35d61&scoped=true"
import script from "./MonitoringScreen.vue?vue&type=script&lang=js"
export * from "./MonitoringScreen.vue?vue&type=script&lang=js"

import "./MonitoringScreen.vue?vue&type=style&index=0&id=1ff35d61&lang=scss&scoped=true"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff35d61"]])

export default __exports__